module.exports = __webpack_public_path__ + "img/img_1.7a0f59a5.png";